import { Controller } from "../../lib/stimulus-shim"

// profiles--text-links : track les clics sur les liens inline du rich text (module texte).
// Delegation sur le wrapper -> pas d'attribut par lien. On ne preventDefault pas :
// interne = nav Turbo (contexte JS conserve), externe = _blank (page conservee) ->
// l'event ahoy part de maniere fiable dans les deux cas.
export default class extends Controller {
  static values = { moduleId: String, moduleType: String }

  track(event) {
    const link = event.target.closest("a[href]")
    if (!link || !this.element.contains(link)) return
    if (typeof ahoy === "undefined") return
    if (document.querySelector('meta[name="rho-owner"]')) return

    ahoy.track("link_click", {
      profile_id: this.#profileId(),
      link_url: link.href,
      link_text: link.textContent.trim(),
      module_type: this.moduleTypeValue,
      module_id: this.moduleIdValue,
      referrer: window.location.href
    })
  }

  #profileId() {
    return document.querySelector('meta[name="profile-id"]')?.content ||
           document.querySelector("[data-profile-id]")?.dataset.profileId
  }
}
